import React, { useEffect, useState } from "react";

import ReserveFormWizard from "./ReserveFormWizard";
import PersonalDetails from "./step-1/PersonalDetails";
import ChooseTime from "./step-2/ChooseTime";
import Agreement from "./step-3/Agreement";
import ConfirmationStep from "./step-4/ConfirmationStep";
import { FORM_KEY, RADIO_BOOLEAN_KEYS } from "../../constants/constants";
import axios from "../../http/axios";

import { store, useGlobalState } from "state-pool";

const ReserveForm = () => {
  const [initialValues, setInitialValues] = useState(undefined);
  const [sessions, setSessions] = useState([]);
  const [recaptcha, setRecaptcha] = useState([]);
  const [warningPopup, setWarningPopup] = useState([]);
  const [isValidEarlyBird, setEralyBirdStatus] = useState(false);
  const [earlyBirdStatusChecked, setEarlyBirdStatusChecked] = useState(false);
  const [earlyBirdKey, setEralyBirdKey] = useState("");
  const [popupQuestion, setPopupQuestion] = useState(null);
  const [activeConfirmationText, setActiveConfirmationText] = useState([]);
  const [activeQuestionary, setActiveQuestionary] = useState([]);

  const [
    clearSecondStepForm,
    setClearSecondStepForm,
    updateClearSecondStepForm,
  ] = useGlobalState("clearSecondStepForm");

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const earlyBirdKey = searchParams.get("earlybird");
    setEralyBirdKey(earlyBirdKey);

    axios
      .get("/recaptcha-settings")
      .then((r) => {
        setRecaptcha(r.data);
      })
      .catch((err) => {});

    axios
      .get("/public/popup-questions/active")
      .then((r) => {
        setPopupQuestion(r.data);
      })
      .catch((err) => {
        setPopupQuestion(null);
      });

    axios
      .get("/early-bird")
      .then((r) => {
        setWarningPopup(r.data);
      })
      .catch(() => {});

    axios
        .get("/public/questionnaires/active")
        .then((r) => {
          if (r.data) {
            setActiveQuestionary(r.data ?? null);
          } else {
            setActiveQuestionary(null);
          }
        })
        .catch((_) => {
          setActiveQuestionary(null);
        });

    if (earlyBirdKey) {
      axios
        .get(`/public/sessions?earlyBirdKey=${earlyBirdKey}`)
        .then((r) => {
          setSessions(r.data);
        })
        .catch((err) => {});
      axios
        .get(`/early-bird/is-valid-key?key=${earlyBirdKey}`)
        .then((r) => {
          setEralyBirdStatus(r.data);
          setEarlyBirdStatusChecked(true);
        })
        .catch(() => {
          setEarlyBirdStatusChecked(true);
        });
    } else {
      axios
        .get("/public/sessions")
        .then((r) => {
          setSessions(r.data);
        })
        .catch((err) => {});
      setEralyBirdStatus(false);
      setEarlyBirdStatusChecked(true);
    }
  }, []);

  useEffect(() => {
    if (!earlyBirdStatusChecked) return;

    axios
      .get(`/public/confirmation-texts/active?isEarlyBird=${isValidEarlyBird}`)
      .then((r) => {
        if (r.data) {
          setActiveConfirmationText(r.data ?? null);
        } else {
          setActiveConfirmationText(null);
        }
      })
      .catch((_) => {
        setActiveConfirmationText(null);
      });
  }, [earlyBirdStatusChecked, isValidEarlyBird]);

  useEffect(() => {
    const saved = sessionStorage.getItem(FORM_KEY);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setInitialValues(parsed);
      } catch (e) {
        setInitialValues({ children: [{}] });
      }
    } else {
      setInitialValues({ children: [{}] });
    }
  }, []);

  const onSubmit = (values) => {
    let body = {
      earlyBirdKey: earlyBirdKey,
    };
    const radioKeys = Object.keys(RADIO_BOOLEAN_KEYS);
    Object.keys(values).forEach((key) => {
      const val = values[key];
      if (radioKeys.includes(key)) {
        body[key] = val === "true";
      } else if (key === "children") {
        body[key] = val.map((student) => {
          const childBody = {};
          Object.keys(student).forEach((key) => {
            const val = student[key];
            if (radioKeys.includes(key)) {
              childBody[key] = val === "true";
            } else {
              childBody[key] = val;
            }
          });
          return childBody;
        });
      } else if (key === "additionalParents") {
        body[key] = val.map(({ emailVerify, ...rest }) => rest);
      } else {
        body[key] = val;
      }
    });

    body.children.forEach((child) => {
      child.birthday = new Date(child.birthday);
    });
    delete body.agreementCheck;
    delete body.emailVerify;
    return axios.post("/reservations", body);
  };

  return (
    <div className="register-page">
      <div className="content-block container mt-5">
        {initialValues !== undefined && (
          <ReserveFormWizard
            clearSecondStepForm={clearSecondStepForm}
            initialValues={initialValues}
            onSubmit={onSubmit}
            recaptcha={recaptcha}
            popupQuestion={popupQuestion}
            warningPopup={warningPopup}
            isValidEarlyBird={isValidEarlyBird}
            warningPopupEnabled={warningPopup.enabled}
          >
            <ReserveFormWizard.Page>
              <PersonalDetails
                  activeQuestionary={activeQuestionary}
              />
            </ReserveFormWizard.Page>
            <ReserveFormWizard.Page>
              <ChooseTime
                  sessions={sessions}
                  activeQuestionary={activeQuestionary}
              />
            </ReserveFormWizard.Page>
            <ReserveFormWizard.Page>
              <Agreement />
            </ReserveFormWizard.Page>
            <ReserveFormWizard.Page>
              <ConfirmationStep
                activeConfirmationText={activeConfirmationText}
              />
            </ReserveFormWizard.Page>
          </ReserveFormWizard>
        )}
      </div>
    </div>
  );
};

export default ReserveForm;
